/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Page_IntroInputs */

const tr_faq_page_intro = /** @type {(inputs: Faq_Page_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aklına takılan soruların cevabını burada bulabilirsin. Bulamadığın bir şey mi var? Destek ekibimize ulaşabilirsin.`)
};

const en_faq_page_intro = /** @type {(inputs: Faq_Page_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find answers to common questions below. Still need help? Reach out to our support team.`)
};

const de_faq_page_intro = /** @type {(inputs: Faq_Page_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier findest du Antworten auf die häufigsten Fragen. Noch Fragen? Schreib unserem Support.`)
};

const ru_faq_page_intro = /** @type {(inputs: Faq_Page_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Здесь вы найдёте ответы на самые частые вопросы. Не нашли нужного? Свяжитесь с нашей поддержкой.`)
};

/**
* | output |
* | --- |
* | "Find answers to common questions below. Still need help? Reach out to our support team." |
*
* @param {Faq_Page_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_page_intro = /** @type {((inputs?: Faq_Page_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Page_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_page_intro(inputs)
	if (locale === "de") return de_faq_page_intro(inputs)
	if (locale === "ru") return ru_faq_page_intro(inputs)
	return tr_faq_page_intro(inputs)
});